import React, { useState } from "react";
import Sidebar from '../../Components/Sidebar/Sidebar'
import '../css/geo.css'
import '../css/Switch.css'
import MaterialTable from "material-table";
import 'material-icons/iconfont/material-icons.css';

function KVI(){
  
  const datos =[
    {artista: 'The Beatles', pais: 'Reino unido', genero: 'Rock, pop', ventas: 1000},
    {artista: 'Eñlvis Presley', pais: 'Estados unidos', genero: 'Rock and roll, country', ventas: 1000},
    {artista: 'Michael Jackson', pais: 'Estados unidos', genero: 'Pop, rock, dance, R&B', ventas: 600},
    {artista: 'Madonna', pais: 'Estados unidos', genero: 'Pop, rock', ventas: 400},
    {artista: 'Elton John', pais: 'Reino unido', genero: 'Pop, rock', ventas: 350}
  ];

  const [data, setData] = useState(datos)

  const columnas= [
    {
      title: 'Artista',
      field: 'artista'
    },
    {
     title: 'País de Origen',
     field: 'pais'
   },
   {
     title: 'Genero(s)',
     field: 'genero'
   },
   {
     title: 'Ventas estimadas (en milones)',
     field: 'ventas',
     type: 'numeric'
   }
   ];

     return (
      <div className="wrapper">
      <nav>
        <Sidebar></Sidebar>
      </nav>
      <div className="marg">
        <h1>KVI</h1>
        <MaterialTable 
          columns={columnas}
          data={data}
          title='Artistas'
          editable={{
            onRowAdd:(newRow)=> new Promise((resolve, reject) =>{
              const updateRows =[...data, newRow]
              setData(updateRows)
              resolve()
              console.log(newRow)
            }),
            onRowDelete:selectedRow => new Promise((resolve, reject) =>{
              const index = selectedRow.tableData.id;
              const updateRows = [...data]
              updateRows.splice(index,1)
              setData(updateRows)
              resolve()
            }),
            onRowUpdate:(updateRow, oldRow)=> new Promise((resolve, reject)=> {
              const index= oldRow.tableData.id;
              const updateRows=[...data]
              updateRows[index]=updateRow
              setData(updateRows)
              resolve()
            })
          }}  
          options={{
            actionsColumnIndex: -1
          }}
          localization={{
            header:{
              actions: 'Acciones'
            },
            body: { editRow: { deleteText: '¿Estás seguro de que quieres borrarlo?' } }
          }}
        />
      </div>
    </div>
    );
}

export default KVI;